import { createTheme } from "@mui/material/styles";

export const DRAWER_WIDTH = 264;
export const HEADER_HEIGHT = 64;
export const BRAND_NAVY = "#0F3D5E";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0C7C74",
      dark: "#0A6861",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#0F3D5E",
      contrastText: "#ffffff",
    },
    success: {
      main: "#15803d",
    },
    warning: {
      main: "#b45309",
    },
    error: {
      main: "#b91c1c",
    },
    info: {
      main: "#1d4ed8",
    },
    background: {
      default: "#F4F7FA",
      paper: "#ffffff",
    },
    text: {
      primary: "#142033",
      secondary: "#64748b",
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#F4F7FA",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: ({ theme: muiTheme }) => ({
          color: muiTheme.palette.primary.main,
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: "#E5EAF0",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.06)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#F4F7FA",
          fontWeight: 600,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        hover: {
          "&:hover": {
            backgroundColor: "#F8FAFC",
          },
        },
      },
    },
  },
});

export default theme;
